@let presentPrompt = pagesEc.assistant.selectors.presentPrompt.asSignal();
@if (presentPrompt) {
  <atn-ds-centered-overlay
    type="narrow"
    class="atn-mosaic-page-ai-generate-dialog"
  >
    <atn-ds-widget title="Generate Ai Page">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="
            pagesEc.assistant.actions.cancelEditPrompt
              .from('Mosaic.Page.Ai.Generate.Dialog.Buttons.Close.Clicked')
              .dispatch()
          "
        ></i>
      </div>

      <div class="atn-mosaic-page-ai-generate-dialog__body">
        <div class="atn-mosaic-page-ai-generate-dialog__prompt">
          @let prompt = pagesEc.assistant.selectors.prompt.asSignal();
          <atn-ds-text-area
            [styleOverrides]="{ height: '100%', resize: 'none' }"
            label="Prompt"
            placeholder="Describe how you want to generate your page (minimum 10 characters required)"
            [value]="prompt"
            (change)="
              pagesEc.assistant.actions.editPrompt
                .from('Mosaic.Page.Ai.Generate.Dialog.Prompt.Changed')
                .dispatch({
                  prompt: $event ?? '',
                })
            "
          />
        </div>
        <div class="atn-mosaic-page-ai-generate-dialog__file-upload">
          <atn-ds-file
            [types]="['.xlsx', '.xls']"
            (fileChange)="
              $event &&
                this.pagesEc.assistant.actions.setFile
                  .from('Mosaic.Page.Ai.Generate.Dialog.File.Changed')
                  .dispatch({
                    file: $event,
                  })
            "
          />
        </div>
      </div>

      <div
        footer
        class="atn-mosaic-page-ai-generate-dialog__footer"
      >
        @let error = pagesEc.assistant.selectors.generatingError.asSignal();
        @if (error) {
          <div class="atn-mosaic-page-ai-generate-dialog__error">
            {{ error }}
          </div>
        }

        <atn-ds-button
          type="transparent"
          (click)="
            pagesEc.assistant.actions.cancelEditPrompt
              .from('Mosaic.Page.Ai.Generate.Dialog.Buttons.Cancel.Clicked')
              .dispatch()
          "
          >Cancel</atn-ds-button
        >
        @let canGenerate = pagesEc.assistant.selectors.canGenerate.asSignal();
        @let isGenerating = pagesEc.assistant.selectors.isGenerating.asSignal();
        <atn-ds-button
          [disabled]="!canGenerate"
          [loading]="isGenerating"
          (click)="generateClickHandler()"
        >
          Generate
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
